import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectHomeEngineeringAlerts } from "../../redux/selector";
import { useStyles } from "./styles";

const fallbackRows = [
  {
    id: 1,
    source: "WO-5501",
    valueKey: "HOME.ENGINEERING_ALERT_VALUES.SCANIA_R500",
    fallbackValue: "Scania R500 - refrigerated box body weight distribution check",
  },
  {
    id: 2,
    source: "WO-5502",
    valueKey: "HOME.ENGINEERING_ALERT_VALUES.ISUZU_FSR",
    fallbackValue: "Isuzu FSR - side curtain sliding rail height check",
  },
  {
    id: 3,
    source: "WO-5503",
    valueKey: "HOME.ENGINEERING_ALERT_VALUES.CENTER_OF_GRAVITY_ERROR",
    fallbackValue: "Error: center of gravity is out of range (> 65%).",
  },
  {
    id: 4,
    source: "WO-5501",
    valueKey: "HOME.ENGINEERING_ALERT_VALUES.SCANIA_R500",
    fallbackValue: "Scania R500 - refrigerated box body weight distribution check",
  },
  {
    id: 5,
    source: "WO-5502",
    valueKey: "HOME.ENGINEERING_ALERT_VALUES.ISUZU_FSR",
    fallbackValue: "Isuzu FSR - side curtain sliding rail height check",
  },
  {
    id: 6,
    source: "WO-5503",
    valueKey: "HOME.ENGINEERING_ALERT_VALUES.CENTER_OF_GRAVITY_ERROR",
    fallbackValue: "Error: center of gravity is out of range (> 65%).",
  },
  {
    id: 7,
    source: "WO-5501",
    valueKey: "HOME.ENGINEERING_ALERT_VALUES.SCANIA_R500",
    fallbackValue: "Scania R500 - refrigerated box body weight distribution check",
  },
  {
    id: 8,
    source: "WO-5502",
    valueKey: "HOME.ENGINEERING_ALERT_VALUES.ISUZU_FSR",
    fallbackValue: "Isuzu FSR - side curtain sliding rail height check",
  },
];

const EngineeringAlerts = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  const reduxRows = useSelector(selectHomeEngineeringAlerts);

  const rows = reduxRows && reduxRows.length > 0 ? reduxRows : fallbackRows;

  const getTranslatedValue = (row: any) => {
    if (row.valueKey) {
      return t(row.valueKey, {
        defaultValue: row.fallbackValue || row.value || "",
      });
    }

    return row.value || "";
  };

  return (
    <Box className={styles.card}>
      <Typography className={styles.title}>
        {t("HOME.ENGINEERING_ALERTS")}
      </Typography>

      <Box className={styles.tableHeader}>
        <Typography>{t("HOME.SOURCE")}</Typography>
        <Typography>{t("HOME.VALUE")}</Typography>
      </Box>

      <Box className={styles.tableBody}>
        {rows.map((row, index) => (
          <Box key={`${row.source}-${index}`} className={styles.tableRow}>
            <Typography className={styles.link}>{row.source}</Typography>

            <Typography className={styles.text}>
              {getTranslatedValue(row)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default EngineeringAlerts;